import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "purple-purple-color center-x py-3"
}

import { IonAccordionGroup, IonCol, IonContent, IonGrid, IonRow } from "@ionic/vue";
import { ref, computed, onMounted } from "vue";
import { route } from "@/router";
import { t } from "@/plugins/vue-i18n";

import OrderTimer from "@/components/modal/OrderTimer.vue";
import AddOrderTimer from "@/components/modal/AddOrderTimer.vue";

import { useListStore } from "@/stores/lists";
import { useUserStore } from "@/stores/user";

import { stopEventAtTop } from "@/functions/modal";
import { replaceToast } from "@/functions/baseToast";
import { popAlertConfirm } from "@/functions/alert";
import { removeInputFocus } from "@/functions/others";

import { Reminder } from "@/types/supplier";
import { PERMISSION_KEY } from "@/types/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderNotificationTimer',
  props: {
    listId: {},
    noTitle: { type: Boolean }
  },
  setup(__props: any) {

const listStore = useListStore()
const userStore = useUserStore()

const props = __props

const remindersLoaded = ref(false)
const counter = ref<number>(0)
const emptyReminder = ref(new Reminder())

const locationId = computed<string>(() => String(route.value.params.locationId ?? ''))
const listId = computed<string>(() => props.listId ?? String(route.value.params.listId ?? ''))

const editTimer = async (timer: Reminder): Promise<void> => {
    if (!timer.id) return

    const response = await listStore.editReminder(locationId.value, listId.value, timer)
    if (response) await replaceToast({
        message: t('success.editReminder'),
        id: 'edit-reminder-success',
        cssClass: 'toast-offset-70'
    })

    await setup()
}

const addTimer = async (timer: Reminder): Promise<void> => {
    //*Add Timer to list
    const response = await listStore.addReminder(locationId.value, listId.value, timer)

    if (response) await replaceToast({
        message: t('success.addReminder'),
        id: 'add-reminder-success',
        cssClass: 'toast-offset-70'
    })

    await setup()

    emptyReminder.value = new Reminder()
    counter.value++
}

const deleteTimer = async (timerId: string): Promise<void> => {
    const response = await listStore.deleteReminder(locationId.value, listId.value, timerId)

    if (response) await replaceToast({
        message: t('success.deleteReminder'),
        id: 'delete-reminder-success',
        cssClass: 'toast-offset-70'
    })
    await setup()
}

const deleteTimerCheck = async (timerId: string): Promise<void> => {
    await popAlertConfirm({
        message: t('alert.delete.reminder'),
        handler: {
            ok: () => deleteTimer(timerId)
        }
    })
}

const setup = async (): Promise<void> => {
    await listStore.getReminders(locationId.value, listId.value)
    remindersLoaded.value = true
}

onMounted(() => {
    setup()
})

return (_ctx: any,_cache: any) => {
  const _directive_scrollbar = _resolveDirective("scrollbar")!

  return _withDirectives((_openBlock(), _createBlock(_unref(IonContent), {
    class: "light-light-background",
    onTouchmove: _unref(stopEventAtTop)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonGrid), { class: "light-light-background p-2" }, {
        default: _withCtx(() => [
          (!__props.noTitle)
            ? (_openBlock(), _createBlock(_unref(IonRow), {
                key: 0,
                class: "py-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), { class: "fw-b purple-purple-color ion-text-center fs-larger" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('titleRoute.orderNotificationTimer')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonAccordionGroup), {
            onIonChange: _unref(removeInputFocus),
            value: (!_unref(listStore).reminders[listId.value]?.count && remindersLoaded.value) ? 'new' : ''
          }, {
            default: _withCtx(() => [
              (_unref(userStore).permission[_unref(PERMISSION_KEY).LIST_REMINDER_CREATE])
                ? (_openBlock(), _createBlock(AddOrderTimer, {
                    "css-class": "purple-purple-color",
                    timer: emptyReminder.value,
                    onSave: addTimer,
                    key: counter.value
                  }, null, 8, ["timer"]))
                : (!_unref(listStore).reminders[listId.value]?.count && remindersLoaded.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('messages.list.noReminder')), 1))
                  : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listStore).reminders[listId.value]?.data, (timer) => {
                return (_openBlock(), _createBlock(OrderTimer, {
                  key: timer,
                  "css-class": "purple-purple-color",
                  timer: timer,
                  "list-id": listId.value,
                  onDeleteTimer: _cache[0] || (_cache[0] = ($event: any) => (deleteTimerCheck($event.id))),
                  onEditTimer: editTimer
                }, null, 8, ["timer", "list-id"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["onIonChange", "value"])
        ]),
        _: 1
      }),
      _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"height":"50px"} }, null, -1))
    ]),
    _: 1
  }, 8, ["onTouchmove"])), [
    [_directive_scrollbar]
  ])
}
}

})